import SwitchInput from './SwitchInput';

export * from './SwitchInput';

export default SwitchInput;
